
import React, { useEffect, useState } from "react";
import "./assets/css/material-dashboard-react.css";
import {
  BrowserRouter,
} from "react-router-dom";
import { Helmet } from 'react-helmet';
import "./assets/css/quill.snow.css";
import { ThemeProvider, createTheme } from '@mui/material/styles';

import { DandDPaletteOptions } from "./DandDPalette";
import { PALETTE } from "@dndModels/Constants";

import NavBar from "@components/Navigation/NavBar";
import MainPage from "@views/MainPage";

import LoadingBox from "@components/input/LoadingBox";
import DandDAPI from "@dndUtilities/system_api";

const api = DandDAPI.getInstance();

export default function AppLayout() {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [login_open, setLoginOpen] = useState(false);
  const [theme, setTheme] = useState(createTheme({ palette: PALETTE as DandDPaletteOptions }));

  useEffect(() => {
    if (!fetched) {
      if (!api.user) {
        setLoading(true);
        const userObjStr = localStorage.getItem("loginUser");
        if (userObjStr) {
          const userObj = JSON.parse(userObjStr);
          const user = userObj.body;
          api.login(user, true).then(() => {
            setLoading(false);
          });
        } else {
          setLoading(false);
        }
      }
      if (window.location.pathname.includes("printable")) {
        setTheme(createTheme({
          palette: {
            primary: {
              light: "#5F9EA0",
              main: "#5F9EA0",
              dark: "#2F4F4F"
            },
            secondary: {
              light: "#5F9EA0", 
              main: "#1c3623",
              dark: "#105422"
            }
          }
        }));
        document.body.style.backgroundColor = "white";
        document.body.style.color = "black";
      }
      setFetched(true);
    }
  }, [fetched]); 

  const toggleLogin = () => {
    const curr = login_open;
    setLoginOpen(!curr);
    if (curr) {
      api.subscription_holder.reload();
    }
  }

  const real_render = () =>{
    if (!fetched || loading) {
      return (<div className="centered"><LoadingBox size={window.innerHeight * 0.5} height={window.innerHeight - 81} /></div>);
    } else {
      return (
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}>
          <Helmet>
            <title>Homebrew Labs</title>
          </Helmet>
          <div>
            { !window.location.pathname.includes("printable") && 
              <div><NavBar toggleLogin={toggleLogin} /></div>
            }
            <div><MainPage loginOpen={login_open} toggleLogin={toggleLogin} /></div>
          </div>
        </BrowserRouter>
      );
    }
  }

  return (
    <ThemeProvider theme={theme}>
      { real_render() }
    </ThemeProvider>
  );
}